<template>
	<div>
		<tab name="6">{{id}} {{activityName}} <b v-if="haveEditAudit" class="color-danger">存在还未处理的演出修改审核，请处理后再编辑演出信息</b>
		</tab>

		<el-tabs type="border-card" v-model="tabValue">
			<el-tab-pane name="1">
				<span slot="label"><i class="el-icon-mic"></i> 赠票种类</span>
				<template v-if="tabValue == '1'">
					<ticket-prices-list :activityId="id" :activityName.sync="activityName"
						:haveEditAudit.sync="haveEditAudit" :isSeat.sync="isSeat"
						@updateRecordsList="$refs.presentRecordsList.getDataList()"></ticket-prices-list>
				</template>
			</el-tab-pane>
			<el-tab-pane name="2">
				<span slot="label"><i class="el-icon-user"></i> 手机号发放记录</span>
				<template v-if="tabValue == '2'">
					<present-records-list ref="presentRecordsList" :activityId="id" :haveEditAudit.sync="haveEditAudit"
						:isSeat.sync="isSeat"></present-records-list>
				</template>
			</el-tab-pane>
			<el-tab-pane name="3">
				<span slot="label"><i class="el-icon-goods"></i> 兑换码兑换记录</span>
				<template v-if="tabValue == '3'">
					<redeem-code-records :activityId="id" :haveEditAudit.sync="haveEditAudit"
						:isSeat.sync="isSeat"></redeem-code-records>
				</template>
			</el-tab-pane>
			<el-tab-pane name="4">
				<span slot="label"><i class="el-icon-coin"></i> 积分兑换赠票记录</span>
				<template v-if="tabValue == '4'">
					<points-redeem-list :activityId="id" :haveEditAudit.sync="haveEditAudit"></points-redeem-list>
				</template>
			</el-tab-pane>
		</el-tabs>
	</div>

</template>

<script>
	import Tab from '../components/tab';
	import TicketPricesList from './components/ticket-prices-list'
	import PresentRecordsList from './components/present-records-list'
	import RedeemCodeRecords from './components/redeem-code-records.vue'
	import PointsRedeemList from './components/points-redeem-list.vue'
	export default {
		props: {
			id: {
				type: [Number, String],
				default: () => null
			}
		},
		components: {
			Tab,
			TicketPricesList,
			PresentRecordsList,
			RedeemCodeRecords,
			PointsRedeemList
		},
		data() {
			return {
				activityName: '',
				haveEditAudit: false,
				redirect: this.$route.query.redirect,
				tabValue: "1",
				isSeat: 0,
			}
		},
		methods: {

		}
	}
</script>
<style lang="scss" scoped>
	.noAction {
		padding: 50px 0;
		text-align: center;
		font-size: 16px;
	}
</style>